import { createContext, useEffect, useState } from "react";
import { format } from "date-fns";
import { sanitizeText } from "./utilityClass";
import { realtimeDB } from "./Backend";
import { off, onValue, ref } from "firebase/database";


export const DataContext = createContext();
export const DataContextProvider = ({children})=>{
    const [userName, setUserName] = useState(null);
    const [userID, setUserID] = useState(null);
    const [userLocation, setUserLocation] = useState("");
    const [isAdmin, setIsAdmin] = useState(null);
    // const Socketio = io("http://192.168.0.185:3500");


    useEffect(()=>{
        const localname = localStorage.getItem("name_id");
        const static_id = localStorage.getItem("user_id");
        const user_location = localStorage.getItem("location_id");
        const randName = `user${Math.floor(Math.random() * 1000000)}`;
        const randID = `${format(new Date(), "yyyyMMddHHmmss")}${Math.floor(Math.random() * 1000000)}`;

        if (localname) {
            setUserName(localname);
        }else{
            setUserName(randName);
        }
        if (static_id) {
            setUserID(sanitizeText(static_id));
        }else{
            setUserID(randID);
        }
        if (user_location) {
            setUserLocation(user_location);
        }else{
            setUserLocation("");
        }

        const adminRef1 = ref(realtimeDB, `admin/${sanitizeText(static_id ? static_id : randID)}`);
        const adminRef2 = ref(realtimeDB, `admin/${sanitizeText(localname ? localname : randName)}`);

        const adminListener1 = onValue(adminRef1, (snapshot)=>{
            if (snapshot.exists()) {
                setIsAdmin(true);
            }
        });

        const adminListener2 = onValue(adminRef2, (snapshot)=>{
            if (snapshot.exists()) {
                setIsAdmin(true);
            }
        });

        return()=>{
            off(adminRef1, 'value', adminListener1);
            off(adminRef2, 'value', adminListener2);
        }
    },[]);

    return(
        <DataContext.Provider value={{
            userName,
            userID,
            userLocation,
            isAdmin
            }}>
            {children}
        </DataContext.Provider>
    )
}